export default __webpack_public_path__ + "static/patronat_honorowy_politechniki-2d87d97a42dbe3a3ee5c076db58f420b.png";